export default __webpack_public_path__ + "static/media/linkedinIcon.8b642ffa.png";